"use strict";

Shopify.theme.jsAccounts = {
  init: function init($section) {
    
    var url_cle = window.location.search;
    const urlParams = new URLSearchParams(url_cle);
    const cle = urlParams.get('cle');

    var recover_email = document.querySelector('.reset-password-wrapper form #recover-email');
    
    if (cle) {
      
      if(recover_email) {
        document.querySelector('.reset-password-wrapper .loader-heart').classList.add("loading");
        document.querySelector('.reset-form-wrap > h3').style.webkitFilter = "blur(2px)";
        document.querySelector('.reset-form-wrap > form').style.webkitFilter = "blur(2px)";
      
        document.querySelector('.reset-password-wrapper form #recover-email').value = cle;
        document.querySelector('.reset-password-wrapper form .form-actions > button[type="submit"]').click();
      }

    }
    
    $('.js-recover-password').on('click', function () {
      $('#login').hide();
      $('#recover').show();
    });
    $('.cancel-recover-password').on('click', function () {
      $('#recover').hide();
      $('#login').show();
    });
 
  },
  unload: function unload($section) {
    $('.js-recover-password').off();
    $('.cancel-recover-password').off();
  }
};